/* Mixins */
import i18n from 'lg-vue-components/mixins/i18n';
import routerFuncao from 'lg-vue-components/mixins/routerFuncao';

/* LG Components */
import clickOutside from 'lg-vue-components/directives/clickOutside';
import visibilityChange from 'lg-vue-components/directives/visibilityChange';

/* PrimeVue */
import PrimeVue from 'primevue/config';

import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';
import BadgeDirective from 'primevue/badgedirective';

export default (app) => {
  app.mixin(i18n);
  app.mixin(routerFuncao);

  app.directive(clickOutside.name, clickOutside);
  app.directive(visibilityChange.name, visibilityChange);

  app.use(PrimeVue, { ripple: true });

  app.directive('ripple', Ripple);
  app.directive('tooltip', Tooltip);
  app.directive('badge', BadgeDirective);
};
